/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SharedTrackingContainer_user$ref = any;
export type SharedTrackingContainer_user = {
    readonly serviceId: string | null;
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": SharedTrackingContainer_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedTrackingContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'd2801a05d6c3b022ead4351dee42082d';
export default node;
